module.exports = __webpack_public_path__ + "img/test.167572c8.png";